import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, itemId: Number }

  save(event) {
    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this._send(event.target), 500)
  }

  _send(field) {
    const body = new FormData()
    body.append("item_id", this.itemIdValue)
    body.append(field.dataset.field, field.value)

    fetch(this.urlValue, {
      method: "PATCH",
      headers: { "X-CSRF-Token": document.querySelector("[name='csrf-token']").content },
      body
    })
  }
}
